import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "app-networking",
  "use": "app-networking-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol viewBox=\"0 0 50 50\" id=\"app-networking\"><defs><style>#app-networking .cls-1{fill:#3badf6;}#app-networking .cls-2{fill:#fff;}</style></defs><title>资源 41</title><g id=\"app-networking_图层_2\" data-name=\"图层 2\"><g id=\"app-networking_图层_1-2\" data-name=\"图层 1\"><rect class=\"cls-1\" width=\"50\" height=\"50\" /><path class=\"cls-2\" d=\"M32.5,23.25h0a7.74,7.74,0,0,0-15.48,0,6.5,6.5,0,0,0,.49,13h5.36a2.56,2.56,0,0,1,1-2.44l-2-2a1.67,1.67,0,0,1-.72.17,1.69,1.69,0,1,1,1.69-1.69,1.67,1.67,0,0,1-.17.72l2.21,2.21a2.53,2.53,0,0,1,1.52,0l2.47-3.69a2.13,2.13,0,0,1-.27-2.62,2.25,2.25,0,1,1,2,3.38,2.22,2.22,0,0,1-.79-.14L27.4,33.76a2.56,2.56,0,0,1,1,2.49H32.5a6.5,6.5,0,0,0,0-13Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/app-networking.svg
// module id = 2wsP
// module chunks = 264